module.exports = __webpack_public_path__ + "img/linkedin.2701511e.svg";